import {
  INIT_TODAY_BOOKINGS,
  UPDATE_TODAY_BOOKING,
  ADD_TODAY_BOOKING,
  DEL_TODAY_BOOKING,
  ERR_TODAY_BOOKING,
  LOADING_TODAY_BOOKING
} from './actions';

const initValue = {
  bookings: [],
  loading: false,
  error: null
};

const today = (state = initValue, action) => {
  switch (action.type) {
    case ERR_TODAY_BOOKING: {
      state.error = action.payload.error;
      return { ...state };
    }

    case LOADING_TODAY_BOOKING: {
      state.loading = action.payload.loading;
      return { ...state };
    }

    case INIT_TODAY_BOOKINGS: {
      const { bookings } = action.payload;
      state.bookings = bookings ? [...bookings] : [];
      return { ...state };
    }

    case UPDATE_TODAY_BOOKING: {
      const { booking } = action.payload;
      state.bookings = state.bookings.filter(e => e.referenceID !== booking.referenceID);
      state.bookings = [booking, ...state.bookings];
      return { ...state };
    }

    case ADD_TODAY_BOOKING: {
      const { booking } = action.payload;
      state.bookings = [booking, ...state.bookings];
      return { ...state };
    }

    case DEL_TODAY_BOOKING: {
      const { booking } = action.payload;
      state.bookings = state.bookings.filter(e => e.referenceID !== booking.referenceID);
      return { ...state };
    }

    default:
      return state;
  }
};

export default today;
